<template lang="pug">
.container-fluid.px-0
  .container-fluid.px-0.d-flex.justify-content-center
    br
    br
    <input type="text"/>
    <button class="btn btn-primary" v-clipboard="copyData" @click="copyCoupon"><i class="fa-solid fa-copy"></i></button>
</template>

<script>

export default{
  data () {
    return {
      copyData: 'copy data'
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    copyCoupon () {
      this.$fire({
        // toast: true,
        icon: 'success',
        position: 'center',
        showConfirmButton: false,
        timer: 1000,
        title: 'copied successfully'
      })
    }
  },
  watch: {

  }
}
</script>
<style lang="scss" scoped>
//mobile 688 desk1270
</style>



// WEBPACK FOOTER //
// src/components/pages/activityTest.vue